import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from '@/store/features/auth/authSlice';
import filtersReducer from '@/store/features/filters/filterSlice';
import modalReducer from '@/store/features/modal/modalSlice';
import quickAppointment from '@/store/features/quick_appointment/quickAppointment';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filters: filtersReducer,
    modal: modalReducer,
    quick_appointment: quickAppointment,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: import.meta.env.MODE === 'development',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
